import { IWebBanner, IVariationContainer, ILearningCenterConfigurationFields } from '@/types/contentful';


function getVariationContainerCategoryBanner(
  variationContainer: IVariationContainer,
  currentCategorySlug: string | undefined,
  defaultBanner: any
): any {
  const { fields } = variationContainer;
  
  if (!fields.variations || fields.variations.length === 0) {
    return defaultBanner;
  }

  for (const variation of fields.variations) {
    if (variation.fields?.pageBlock) {
      const pageBlock = variation.fields.pageBlock;
      
      if (pageBlock.sys.contentType.sys.id === 'webBanner') {
        const webBanner = pageBlock as IWebBanner;
        const bannerCategory = webBanner.fields.learningCenterCategory;
        
        if (bannerCategory && bannerCategory.fields.slug === currentCategorySlug) {
          return webBanner;
        }
      } else if (pageBlock.sys.contentType.sys.id === 'variationContainer') {
        const nestedVariationContainer = pageBlock as IVariationContainer;
        const nestedResult = getVariationContainerCategoryBanner(
          nestedVariationContainer,
          currentCategorySlug,
          defaultBanner
        );
        
        if (nestedResult !== defaultBanner) {
          return nestedResult;
        }
      }
    }
  }

  return defaultBanner;
}

export function getLearningCenterBanner(
  articleConfig: ILearningCenterConfigurationFields | undefined,
  currentCategorySlug: string | undefined,
  defaultBanner: any
): any {
  const categorySpecificWebBanner = articleConfig?.categorySpecificWebBanner;
  
  if (!categorySpecificWebBanner || categorySpecificWebBanner.length === 0) {
    return defaultBanner;
  }

  for (const banner of categorySpecificWebBanner) {
    const contentTypeId = (banner as any).sys.contentType.sys.id;
    
    if (contentTypeId === 'variationContainer') {
      const variationContainer = banner as any as IVariationContainer;
      const matchedBanner = getVariationContainerCategoryBanner(
        variationContainer,
        currentCategorySlug,
        defaultBanner
      );
      
      // Only return if we found a specific webBanner, not the variation container itself
      if (matchedBanner !== defaultBanner && matchedBanner.sys?.contentType?.sys?.id === 'webBanner') {
        return matchedBanner;
      }
    } else if (contentTypeId === 'webBanner') {
      const webBanner = banner as any as IWebBanner;
      const bannerCategory = webBanner.fields.learningCenterCategory;
      
      if (bannerCategory && bannerCategory.fields.slug === currentCategorySlug) {
        return webBanner;
      }
    }
  }

  return defaultBanner;
}
